import React, {useState} from 'react';
import { GxButton, GxIcon } from '@garpix/garpix-web-components-react';
import { useStoreon } from 'storeon/react';
import { Events, State } from '@/interfaces';
import Logo from '../Logo';
import MenuIconSVG from '../../assets/icons/menuIcon.svg';
import style from './styles/index.module.scss';
import {PhoneIcon} from '../../assets';
import {getCookie, setCookie} from '../../utils';
import {ATC_TYPE} from '../../types';
import UserAccount from '../UserAccount/UserAccount';
import {TYPE_USER} from '../../const';

interface IHeader {
  isOpenSidebar: boolean;
  toggleVisibleSidebar: ()=>void;
  type?: ATC_TYPE
}

const Header: React.FC<IHeader> = ({toggleVisibleSidebar }) => {
  const { dispatch, currentUser } = useStoreon<State, Events>('currentUser', 'showModalCall');
  const [operatorId, setOperatorId] = useState<string | null>(getCookie('operatorAtcNumber') );


  const openModalCall = (): void => {
    dispatch('modalCall/show', true)
    dispatch('modalCall/setInfo', {
      type: 'DEFAULT',
      phone: ''
    });
  }

  const handleChangeInput = (e: Record<string, any>) => {
    const data = e.target.value;
    const newData =  data.replace(/[^0-9]/g, '');
    if (data > 4) {
      setOperatorId(newData.slice(0,4));
      setCookie('operatorAtcNumber', newData, 365);
    }else{
      setCookie('operatorAtcNumber',newData,365);
      setOperatorId(newData)
    }
  }

  return (
    <header className={style.header}>
      <div className={style.header__right_group}>
        <GxButton className={style['btn--open']} onClick={toggleVisibleSidebar}>
          <GxIcon className={style['icon']} src={MenuIconSVG} />
        </GxButton>
        <div>
          <Logo />
        </div>
      </div>
      <div className={style.header__left_group}>
        { currentUser.user_status !== TYPE_USER.VIEWER &&
        <>
          <GxIcon src={ PhoneIcon } className={ style['person_id--icon'] } onClick={ openModalCall } role='button' tabIndex={ 0 }/>
          <div className={ style['person_id--wrapper'] }>
            <input value={ operatorId !== null ? operatorId : '' } className={ style['person_id--wrapper-block'] } onChange={ handleChangeInput }
                   type='text' pattern="^[0-9]+$"/>
          </div>
        </>
        }
        <span className={style['person_id--username']}>{`${currentUser.last_name} ${currentUser.first_name}`}</span>
        <UserAccount/>
      </div>
    </header>
  );
};
export default Header;
